import { TServicesCardsExperimentEventType } from './types';

export const SERVICES_CARDS_EXPERIMENT_EVENT_TYPE: TServicesCardsExperimentEventType = {
  a_default: 'fvu_newest',
  b_views: 'fvu_newest_koeff_views',
  c_shows: 'fvu_newest_koeff_shows',
  d_redesign: 'fvu_newest_redesign',
};
